import client from './client'
import type { UtmParams } from '../hooks/useUtm'

export type { UtmParams }

export interface CampaignStats {
  total_raised: number
  donor_count: number
  goal: number
}

export interface Donation {
  id: number
  display_name: string
  is_anonymous: boolean
  donation_amount: number
  monthly_tier: number
  months: number
  donation_msg: string
  date: string
}

export interface DonationsPage {
  donations: Donation[]
  next_cursor: number | null
}

export interface LeadPayload {
  full_name: string
  display_name: string
  is_anonymous: boolean
  email: string
  phone: string
  monthly_tier: number
  months: number
  donation_amount: number
  donation_msg: string
  utm: UtmParams
}

export interface LeadResponse {
  giving_id: number
}

export const fetchStats = async (): Promise<CampaignStats> => {
  const { data } = await client.get<CampaignStats>('/stats')
  return data
}

export const fetchDonations = async (before_id?: number): Promise<DonationsPage> => {
  const params = before_id ? { before_id } : {}
  const { data } = await client.get<DonationsPage>('/donations', { params })
  return data
}

export const postLead = async (payload: LeadPayload): Promise<LeadResponse> => {
  const { data } = await client.post<LeadResponse>('/lead', payload)
  return data
}

export const checkStatus = async (id: number): Promise<{ status: string }> => {
  const { data } = await client.get<{ status: string }>('/check-status', { params: { id } })
  return data
}

export const postConfirmIntent = async (giving_id: number, raw_json: unknown): Promise<void> => {
  await client.post('/confirm-intent', { giving_id, raw_json })
}
